import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Card, Icon } from '../ui';
import { pageMeta } from '../../config/pages';

// T0 — Accueil refondu : une carte par page (titre/description/icône via pages.js), triée par `order`.
// `tree` = arbre des pages découvertes (App.js). `onNavigate(path)` pour la navigation.
export const HomeGrid = ({ tree, onNavigate }) => {
  const pages = Object.entries(tree)
    .filter(([, value]) => React.isValidElement(value))
    .map(([key]) => ({ key, meta: pageMeta(key) }))
    .sort((a, b) => a.meta.order - b.meta.order);

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Documentation ScanBank</h1>
        <p className="mt-2 text-gray-600 dark:text-gray-300">
          Plateforme de centralisation, validation et analyse des audits bancaires CBS — référentiel fonctionnel, technique et opérationnel.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {pages.map(({ key, meta }) => (
          <motion.div key={key} whileHover={{ y: -4 }}>
            <Card
              className="p-6 cursor-pointer hover:shadow-md transition-shadow h-full group"
              onClick={() => onNavigate(`/${key}`.toLowerCase())}
            >
              <div className="flex items-start gap-4">
                <div className="p-3 rounded-lg bg-blue-50 dark:bg-blue-500/10 text-blue-500 shrink-0">
                  <Icon name={meta.icon} size={24} />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white flex items-center gap-1">
                    {meta.title}
                    <ArrowRight size={16} className="opacity-0 group-hover:opacity-100 -translate-x-1 group-hover:translate-x-0 transition-all" />
                  </h3>
                  <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{meta.description}</p>
                </div>
              </div>
            </Card>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default HomeGrid;
